module.exports = __webpack_public_path__ + "media/subway/B-72af7655.png";